import { ReactNode } from 'react';
import { LayoutChromeContext } from './layoutChrome';

export function EmbeddedLayoutChrome({ children }: { children: ReactNode }) {
  return (
    <LayoutChromeContext.Provider value={{ embedded: true }}>
      {children}
    </LayoutChromeContext.Provider>
  );
}
